import { render } from "./SearchComponent.vue?vue&type=template&id=967f9c5c&ts=true"
import script from "./SearchComponent.vue?vue&type=script&lang=ts"
export * from "./SearchComponent.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./SearchComponent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/var/www/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__